/**
 * Constants for Activity tracking components
 */

// Scroll synchronization
export const SCROLL_SYNC_DEBOUNCE = 10; // milliseconds

// Row and header dimensions
export const DEFAULT_ROW_HEIGHT = 52; // pixels
export const HEADER_HEIGHT = 56; // pixels
export const METRIC_ROWS_COUNT = 4; // Total Customers, Weekly Active, Monthly Active, Separator

// Column dimensions
export const FBO_COLUMN_WIDTH = 200; // pixels
export const WEEK_COLUMN_WIDTH = 140; // pixels

// Table dimensions
export const WEEKLY_ACTIVITY_TABLE_HEIGHT = 600; // pixels
export const RECENT_ACTIVITY_TABLE_HEIGHT = 400; // pixels

// Scrollbar dimensions
export const SCROLLBAR_WIDTH = 14; // pixels
export const SCROLLBAR_HEIGHT = 14; // pixels

// DataGrid pagination
export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [25, 50, 100];
export const RECENT_ACTIVITY_PAGE_SIZE = 20;